import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {UsergroupModel} from './usergroup.model';
import {ChannelModel} from '../channel/channel.model';

@Injectable()
export class UsergroupsApiService extends ReactiveServiceWithFilters  {
    protected baseUrl = environment.backEndUrlPrefix + '/' + 'db/usergroup';

    constructor(protected http: HttpClient) {
        super();
    }

    getAll(userId?: number): Observable<UsergroupModel[]> {
        return this.http.get<UsergroupModel[]>(userId ? this.buildUrl(this.baseUrl) : this.baseUrl);
    }

    getUserGroups(userId: number): Observable<UsergroupModel[]> {
        return this.http.get<UsergroupModel[]>(`${this.baseUrl}/child/user/${userId}`);
    }

    updateGroup(ids: number[], data): Observable<ChannelModel[]> {
      return this.http.patch<ChannelModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
    }

    deleteGroup(ids: number[]): Observable<string> {
        return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UsergroupModel[]> | Promise<UsergroupModel[]> | UsergroupModel[] {
      this.setFilterParams(route);
      return this.getAll();
    }

  unlink(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  protected initFilters() {

    super.initFilters();
    this.filters = {
      usergroupId: 'child/usergroup/:value'
    };
  }
}
